const qk = {
  list: (appId?: string, params?: Record<string, any>) =>
    ["apps", appId, "environments", ...(params ? [params] : [])] as const,

  single: (appId?: string, envId?: string) =>
    [...qk.list(appId), envId] as const,
};

export { qk as environmentQueryKeys };
